<template lang="pug">
tr.vue-time-entries-weekly-table-row
  td.table-data-end
  TimeEntriesWeeklyTableRowTableData(
    v-for="date in dateRange"
    :key="date.format()"
    :date="date"
  )
  td.strong.vue-time-entries-weekly-table-row-table-data
    | -
</template>
<script>
export default {
  name: 'TimeEntriesWeeklyEmptyTableRow',
  props: {
    dateRange: Array,
  },
};
</script>
